import { render } from "./SceneConstructorConstructedBgMenu.vue?vue&type=template&id=45cc0442&ts=true"
import script from "./SceneConstructorConstructedBgMenu.vue?vue&type=script&lang=ts"
export * from "./SceneConstructorConstructedBgMenu.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/azhukovets/.nps/caiman_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__